import Breadcrumbs from "components/Common/Breadcrumb"
import BackButton from "components/Shared/BackButton"
import React, { useEffect, useState } from "react"
import { Button, Card, CardBody, CardTitle, Col, Row } from "reactstrap"
import { Formik, Form, Field, ErrorMessage, FieldArray, getIn } from "formik"
import { useDispatch } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"
import Select from "react-select"
import { getCategories } from "store/actions/categoriesAction"
import { getItemsListDropdown } from "store/actions/itemsAction"
import { addPromotionSchema } from "components/Common/validation"
import Switch from "components/Shared/Switch"
import { getAllBranchs } from "store/actions/usersAction"
import {
  addPromotion,
  getPromotionDetails,
  updatePromotion,
} from "store/actions/promotionsAction"
import { showAlert } from "store/reducers/alertReducer"
import Spinners from "components/Shared/Spinners"
import { allOption } from "components/Common/constants"
import { useTranslation } from "react-i18next"
import TextError from "components/Shared/TextError"
import SensitiveActionOtpModal from "components/Shared/SensitiveActionOtpModal"
import useSensitiveAction from "hooks/useSensitiveAction"
import { SENSITIVE_MODULES } from "helpers/sensitiveActionModules"

const initialValues = {
  name: "",
  offerType: "discount",
  // item: {
  category: "",
  item: "",
  offerPrice: null,
  quantity: null,
  // },
  qualificationType: "order",
  qualificationItems: [],
  cartRules: [],
  availableBranches: [],
  discountType: "fixed",
  // orderType: [],
  amount: null,
  maxAmount: null,
  limits: {
    isMaxUsageOfCustomers: false,
    maxUsageOfCustomers: null,
    isMaxUsagePerCustomer: false,
    maxUsagePerCustomer: null,
  },
  status: 1,
  minimumCartAmount: null,
}

const AddPromotion = ({ mode }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  document.title = `${
    mode === "add" ? t("Add") : t("Edit")
  } ${"Discount | Sign Burger"}`

  // const navigate = useNavigate()

  const location = useLocation()
  const dispatch = useDispatch()
  const searchParams = new URLSearchParams(location.search)
  const id = searchParams.get("id")

  const submitPromotionWithOtp = (values, actionOtp) => {
    const {
      name,
      offerType,
      category,
      item,
      offerPrice,
      quantity,
      qualificationType,
      qualificationItems,
      cartRules,
      availableBranches,
      discountType,
      amount,
      maxAmount,
      limits,
      minimumCartAmount,
    } = values

    const transformedQualificationType =
      offerType === "discount" ? qualificationType : ""

    const transformedQualificationItems = qualificationItems?.map(item => {
      const baseObject = { categoryId: item?.category?.value }
      if (offerType === "item") {
        baseObject.itemId = item?.item?.value
      }
      return baseObject
    })

    const transformedCartRules = isAdvanceSettings
      ? cartRules?.map(item => ({
          categoryId: item?.category?.value,
          itemId: item?.item?.value,
          quantity: item.quantity,
        }))
      : []

    const transformedAvailableBranches = isAdvanceSettings
      ? availableBranches?.map(item => item.value)
      : []

    const payload = {
      actionOtp,
      name,
      offerType,
      qualificationType: transformedQualificationType,
      qualificationItems: transformedQualificationItems,
      cartRules: transformedCartRules,
      availableBranches: transformedAvailableBranches,
      discountType,
      orderType: isAdvanceSettings ? orderType : [],
      amount: amount ?? 0,
      maxAmount: maxAmount ?? 0,
      hasAdvancedSettings: isAdvanceSettings,
      limits: {
        isMaxUsageOfCustomers: limits.isMaxUsageOfCustomers,
        maxUsageOfCustomers: limits.maxUsageOfCustomers,
        isMaxUsagePerCustomer: limits.isMaxUsagePerCustomer,
        maxUsagePerCustomer: limits.maxUsagePerCustomer,
      },
      minimumCartAmount:
        offerType === "item" || offerType === "category"
          ? 0
          : minimumCartAmount,
    }

    if (mode === "add") {
      return dispatch(addPromotion(payload)).then(action => {
        const { statusCode, status, msg } = action?.payload || {}
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
          window.history.back()
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
        return action
      })
    }

    payload.id = id
    return dispatch(updatePromotion(payload)).then(action => {
      const { statusCode, status, msg } = action?.payload || {}
      if (statusCode === 200 && status) {
        dispatch(showAlert({ text: msg, type: "success" }))
        window.history.back()
      } else {
        dispatch(showAlert({ text: msg, type: "error" }))
      }
      return action
    })
  }

  const { startSensitiveAction, modalProps, isActionBusy } = useSensitiveAction({
    module: SENSITIVE_MODULES.PROMOTION,
    onSubmitWithOtp: submitPromotionWithOtp,
  })

  const [formValues, setFormValues] = useState(initialValues)
  const [isAdvanceSettings, setIsAdvanceSettings] = useState(false)
  const [orderType, setOrderType] = useState(["curbside", "pickup"])
  const [tempOfferType, setTempOfferType] = useState(null)
  const { loading, isLoading, promotionDetails } = useSelector(
    state => state.Promotions
  )

  useEffect(() => {
    const fetchPromotionDetails = () => {
      const payload = {
        id,
      }
      dispatch(getPromotionDetails(payload))
    }
    if (mode === "edit") {
      fetchPromotionDetails()
    }
  }, [])

  useEffect(() => {
    if (promotionDetails && mode === "edit") {
      const {
        item,
        limits,
        name,
        offerType,
        qualificationType,
        qualificationItems,
        discountType,
        amount,
        maxAmount,
        minimumCartAmount,
        cartRules,
        orderType,
        availableBranches,
        hasAdvancedSettings,
      } = promotionDetails

      const updatedAvailableBranches = availableBranches?.map(item => ({
        label: language === "sa" ? item.nameAr : item.name,
        value: item._id,
      }))

      var updatedQualificationItems = []

      if (qualificationItems && qualificationItems.length > 0) {
        const data = qualificationItems.map(item => ({
          label:
            language === "sa"
              ? item?.categoryId?.nameAr
              : item?.categoryId?.name || "",
          value: item?.categoryId?._id || "",
          category: {
            label:
              language === "sa"
                ? item?.categoryId?.nameAr
                : item?.categoryId?.name || "",
            value: item?.categoryId?._id || "",
          },
          item: {
            label:
              language === "sa"
                ? item?.itemId?.nameAr
                : item?.itemId?.name || "",
            value: item?.itemId?._id || "",
          },
        }))
        updatedQualificationItems = data
      }
      setOrderType(orderType)

      setFormValues(prevVal => ({
        ...prevVal,
        name,
        offerType,
        qualificationType,
        amount,
        maxAmount,
        limits,
        minimumCartAmount,
        discountType,
        availableBranches: updatedAvailableBranches,
        qualificationItems: updatedQualificationItems,
      }))
      setIsAdvanceSettings(hasAdvancedSettings)
    }
  }, [promotionDetails, mode, language])

  useEffect(() => {
    getCategoriesList()
  }, [])

  const { allCategories } = useSelector(state => state.Categories)
  const { itemsListDropdown } = useSelector(state => state.Items)
  const { branchsList } = useSelector(state => state.Users)

  const getCategoriesList = () => {
    dispatch(getCategories({ isCombo: false }))
  }
  const allItemsList = value => {
    const payload = {
      category: [value],
    }
    dispatch(getItemsListDropdown(payload))
  }

  useEffect(() => {
    fetchAllBranchs()
  }, [])

  const fetchAllBranchs = () => {
    dispatch(getAllBranchs())
  }

  const handleCheckboxChange = e => {
    const { value, checked } = e.target
    if (checked) {
      setOrderType(prevOrderType => [...prevOrderType, value])
    } else {
      setOrderType(prevOrderType => prevOrderType.filter(v => v !== value))
    }
  }

  const handleOnSubmit = values => {
    startSensitiveAction(values)
  }

  const [isAllSelected, setIsAllSelected] = useState(false)

  const branchListOptions = branchsList?.map(item => ({
    label: language === "sa" ? item.nameAr : item.name,
    value: item._id,
  }))

  const options = isAllSelected
    ? branchListOptions
    : [allOption, ...branchListOptions]

  if (mode === "edit" && loading) return <Spinners />

  return (
    <div className="page-content">
      <SensitiveActionOtpModal {...modalProps} />
      <div className="container-fluid">
        <Breadcrumbs />
        <Row>
          <Col xl={12}>
            <Card>
              <CardBody>
                <CardTitle className="mb-2 d-flex align-items-center">
                  <BackButton />
                  {mode === "add" ? t("Add") : t("Edit")} {t("Discount")}
                </CardTitle>
                <div className="d-flex justify-content-between align-items-center mt-2">
                  <CardTitle>{t("Offer")}</CardTitle>
                  <div className="d-flex align-items-center">
                    <label className="mx-2 mb-0">{t("Advance Settings")}</label>
                    <Switch
                      isChecked={isAdvanceSettings}
                      onClickHandler={() => {
                        setIsAdvanceSettings(!isAdvanceSettings)
                      }}
                    />
                  </div>
                </div>
                <Formik
                  initialValues={formValues}
                  enableReinitialize={true}
                  validationSchema={addPromotionSchema(tempOfferType)}
                  onSubmit={handleOnSubmit}
                >
                  {({ values, setFieldValue, errors, touched }) => (
                    <Form>
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="form_field">
                            <label htmlFor="name">
                              <span className="text-danger">*</span>{" "}
                              {t("Discount Name")}
                            </label>
                            <Field
                              type="text"
                              id="name"
                              name="name"
                              placeholder={t("Discount Name")}
                              className={`form-control ${
                                touched.name && errors.name ? "is-invalid" : ""
                              }`}
                            />
                            <TextError name="name" />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="mt-3">
                            <label htmlFor="name">{t("Offer Type")}</label>
                            <div className="d-flex ">
                              <div className="form-check mx-2">
                                <Field
                                  className="form-check-input"
                                  type="radio"
                                  name="offerType"
                                  id="offerTypeDiscount"
                                  value="discount"
                                  onClick={() => {
                                    setFieldValue("offerType", "discount")
                                    setFieldValue("qualificationItems", [])
                                    setTempOfferType(null)
                                  }}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="offerTypeDiscount"
                                >
                                  {t("Discount")}
                                </label>
                              </div>
                              <div className="form-check mx-2">
                                <Field
                                  className="form-check-input"
                                  type="radio"
                                  name="offerType"
                                  id="offerTypeCategory"
                                  value="category"
                                  onClick={() => {
                                    setFieldValue("offerType", "category")
                                    setFieldValue("qualificationItems", [
                                      {
                                        category: null,
                                      },
                                    ])
                                    setTempOfferType("category")
                                  }}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="offerTypeCategory"
                                >
                                  {t("Category")}
                                </label>
                              </div>
                              <div className="form-check mx-2">
                                <Field
                                  className="form-check-input"
                                  type="radio"
                                  name="offerType"
                                  id="offerTypeItem"
                                  value="item"
                                  onClick={() => {
                                    setFieldValue("offerType", "item")
                                    setFieldValue("qualificationItems", [
                                      {
                                        category: null,
                                        item: null,
                                      },
                                    ])
                                    setTempOfferType("item")
                                  }}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="offerTypeItem"
                                >
                                  {t("Item")}
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-12">
                          <div className="mt-3">
                            <label htmlFor="discountType">
                              {t("Discount Type")}
                            </label>
                            <div className="d-flex">
                              <div className="form-check mx-2">
                                <Field
                                  className="form-check-input"
                                  type="radio"
                                  name="discountType"
                                  id="discountTypeFixed"
                                  value="fixed"
                                  onClick={() => {
                                    setFieldValue("discountType", "fixed")
                                  }}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="discountTypeFixed"
                                >
                                  {t("Fixed Discount")}
                                </label>
                              </div>
                              <div className="form-check mx-2">
                                <Field
                                  className="form-check-input"
                                  type="radio"
                                  name="discountType"
                                  id="discountTypePercentage"
                                  value="percentage"
                                  onClick={() => {
                                    setFieldValue("discountType", "percentage")
                                  }}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="discountTypePercentage"
                                >
                                  {t("Percentage")}
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>

                        {values.discountType === "fixed" && (
                          <div className="col-lg-6">
                            <div className="form_field">
                              <label htmlFor="amount">
                                <span className="text-danger">*</span>{" "}
                                {t("Amount")}
                              </label>
                              <Field
                                type="number"
                                id="amount"
                                name="amount"
                                placeholder={t("Amount")}
                                className={`form-control ${
                                  touched.amount && errors.amount
                                    ? "is-invalid"
                                    : ""
                                }`}
                                pattern="[0-9]*"
                              />
                              <TextError name="amount" />
                            </div>
                          </div>
                        )}
                        {values.discountType === "percentage" && (
                          <>
                            <div className="col-lg-6">
                              <div className="form_field">
                                <label htmlFor="name">
                                  <span className="text-danger">*</span>{" "}
                                  {t("Amount")}
                                  (%)
                                </label>
                                <Field
                                  type="number"
                                  id="amount"
                                  name="amount"
                                  placeholder={t("Amount") + "%"}
                                  className={`form-control ${
                                    touched.amount && errors.amount
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                  pattern="[0-9]*"
                                  max="100"
                                />
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="form_field">
                                <label htmlFor="maxAmount">
                                  {t("Maximum Discount")}
                                </label>
                                <Field
                                  type="number"
                                  id="maxAmount"
                                  name="maxAmount"
                                  placeholder={t("Maximum Discount")}
                                  className={`form-control ${
                                    touched.amount && errors.amount
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                  pattern="[0-9]*"
                                  min="0"
                                />
                              </div>
                            </div>
                          </>
                        )}

                        {values.offerType === "category" && (
                          <div className="row mt-3">
                            <label htmlFor="">
                              <span className="text-danger">*</span>{" "}
                              {t("Select Categories")}
                            </label>
                            <FieldArray name="qualificationItems">
                              {({ push, remove }) => (
                                <>
                                  {values.qualificationItems &&
                                    values.qualificationItems.length > 0 &&
                                    values.qualificationItems.map(
                                      (rule, index) => (
                                        <div
                                          className="col-lg-6 mt-2 pe-0"
                                          key={index}
                                        >
                                          <div className="d-flex">
                                            <div className="w-100">
                                              <Select
                                                value={
                                                  values.qualificationItems[
                                                    index
                                                  ].category
                                                }
                                                onChange={selectedValue => {
                                                  allItemsList(
                                                    selectedValue.value
                                                  )
                                                  setFieldValue(
                                                    `qualificationItems[${index}].category`,
                                                    selectedValue
                                                  )
                                                  // setFieldValue(
                                                  //   `qualificationItems[${index}].item`,
                                                  //   null
                                                  // )
                                                }}
                                                options={allCategories.map(
                                                  item => ({
                                                    label:
                                                      language === "sa"
                                                        ? item.nameAr
                                                        : item.name,
                                                    value: item._id,
                                                  })
                                                )}
                                                placeholder={t(
                                                  "Select Category"
                                                )}
                                                className={`select2-selection ${
                                                  getIn(
                                                    touched,
                                                    `qualificationItems[${index}].category`
                                                  ) &&
                                                  getIn(
                                                    errors,
                                                    `qualificationItems[${index}].category`
                                                  )
                                                    ? "danger_color_border"
                                                    : ""
                                                }`}
                                              />
                                              <TextError
                                                name={`qualificationItems[${index}].category`}
                                              />
                                            </div>
                                            {values.qualificationItems.length >
                                              1 && (
                                              <div
                                                style={{
                                                  maxWidth: 100,
                                                  marginLeft: 15,
                                                }}
                                              >
                                                <Button
                                                  color="danger"
                                                  type="button"
                                                  onClick={() => remove(index)}
                                                >
                                                  {t("Remove")}
                                                </Button>
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      )
                                    )}
                                  <div className="mt-3">
                                    <Button
                                      type="button"
                                      onClick={() =>
                                        push({
                                          category: null,
                                        })
                                      }
                                    >
                                      {t("Add Category")}
                                    </Button>
                                  </div>
                                </>
                              )}
                            </FieldArray>
                          </div>
                        )}

                        {values.offerType === "item" && (
                          <div className="row mt-3">
                            <label htmlFor="">
                              <span className="text-danger">*</span>{" "}
                              {t("Select Categories")}
                            </label>
                            <FieldArray name="qualificationItems">
                              {({ push, remove }) => (
                                <>
                                  {values.qualificationItems &&
                                    values.qualificationItems.length > 0 &&
                                    values.qualificationItems.map(
                                      (rule, index) => (
                                        <div className={`row mt-2`} key={index}>
                                          <div className="col">
                                            <Select
                                              value={
                                                values.qualificationItems[index]
                                                  .category
                                              }
                                              onChange={selectedValue => {
                                                allItemsList(
                                                  selectedValue.value
                                                )
                                                setFieldValue(
                                                  `qualificationItems[${index}].category`,
                                                  selectedValue
                                                )
                                                setFieldValue(
                                                  `qualificationItems[${index}].item`,
                                                  null
                                                )
                                              }}
                                              options={allCategories.map(
                                                item => ({
                                                  label:
                                                    language === "sa"
                                                      ? item.nameAr
                                                      : item.name,
                                                  value: item._id,
                                                })
                                              )}
                                              placeholder={t("Select Category")}
                                              className={`select2-selection ${
                                                getIn(
                                                  touched,
                                                  `qualificationItems[${index}].category`
                                                ) &&
                                                getIn(
                                                  errors,
                                                  `qualificationItems[${index}].category`
                                                )
                                                  ? "danger_color_border"
                                                  : ""
                                              }`}
                                            />
                                            <TextError
                                              name={`qualificationItems[${index}].category`}
                                            />
                                          </div>
                                          <div className="col">
                                            <Select
                                              value={
                                                values.qualificationItems[index]
                                                  .item
                                              }
                                              onChange={selectedValue => {
                                                setFieldValue(
                                                  `qualificationItems[${index}].item`,
                                                  selectedValue
                                                )
                                              }}
                                              options={itemsListDropdown?.map(
                                                item => ({
                                                  label:
                                                    language === "sa"
                                                      ? item.nameAr
                                                      : item.name,
                                                  value: item._id,
                                                })
                                              )}
                                              placeholder={t("Select Item")}
                                              className={`select2-selection ${
                                                getIn(
                                                  touched,
                                                  `qualificationItems[${index}].item`
                                                ) &&
                                                getIn(
                                                  errors,
                                                  `qualificationItems[${index}].item`
                                                )
                                                  ? "danger_color_border"
                                                  : ""
                                              }`}
                                            />
                                            <TextError
                                              name={`qualificationItems[${index}].item`}
                                            />
                                          </div>
                                          {values.qualificationItems.length >
                                            1 && (
                                            <div
                                              className="col"
                                              style={{ maxWidth: 100 }}
                                            >
                                              <Button
                                                color="danger"
                                                type="button"
                                                onClick={() => remove(index)}
                                              >
                                                {t("Remove")}
                                              </Button>
                                            </div>
                                          )}
                                        </div>
                                      )
                                    )}
                                  <div className="mt-2">
                                    <Button
                                      type="button"
                                      onClick={() =>
                                        push({
                                          category: null,
                                          item: null,
                                        })
                                      }
                                    >
                                      {t("Add")}
                                    </Button>
                                  </div>
                                </>
                              )}
                            </FieldArray>
                          </div>
                        )}
                        {/* </>
                        )} */}

                        {/* ADVANCE SETTINGS */}
                        {isAdvanceSettings && (
                          <>
                            <hr className="mt-3" />
                            {values.offerType === "category" ||
                            values.offerType === "item" ? null : (
                              <>
                                <CardTitle>
                                  {t("Discount Conditions")}
                                </CardTitle>
                                <div className="col-lg-6">
                                  <div className="mt-2">
                                    <div className="form_field">
                                      <label
                                        className="form-check-label"
                                        htmlFor="minimumCartAmount"
                                      >
                                        {t("Minimum Cart Amount")}
                                      </label>
                                      <Field
                                        type="number"
                                        id="minimumCartAmount"
                                        name="minimumCartAmount"
                                        placeholder={t("Minimum Cart Amount")}
                                        className={`form-control ${
                                          touched.minimumCartAmount &&
                                          errors.minimumCartAmount
                                            ? "is-invalid"
                                            : ""
                                        }`}
                                        pattern="[0-9]*"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </>
                            )}

                            <div className="col-lg-12 mt-2">
                              <label htmlFor="name">{t("Order Type")}</label>

                              <div className="d-flex">
                                <div className="form-check form-check-primary mb-3 ps-0">
                                  <input
                                    type="checkbox"
                                    name="orderType"
                                    value="pickup"
                                    id="pickup"
                                    checked={orderType.includes("pickup")}
                                    onChange={handleCheckboxChange}
                                  />
                                  <label
                                    className="form-check-label mx-2"
                                    htmlFor="pickup"
                                  >
                                    {t("Pickup")}
                                  </label>
                                </div>
                                <div className="form-check form-check-primary mb-3">
                                  <input
                                    type="checkbox"
                                    name="orderType"
                                    value="curbside"
                                    id="curbside"
                                    checked={orderType.includes("curbside")}
                                    onChange={handleCheckboxChange}
                                  />
                                  <label
                                    className="form-check-label mx-2"
                                    htmlFor="curbside"
                                  >
                                    {t("Curbside")}
                                  </label>
                                </div>
                              </div>
                            </div>

                            <div className="col-lg-6">
                              <label htmlFor="">
                                {t("Allow Specific Branches")}
                              </label>
                              <Select
                                value={values.availableBranches}
                                isMulti={true}
                                onChange={selectedValue => {
                                  if (
                                    selectedValue?.find(
                                      option => option.value === "*"
                                    )
                                  ) {
                                    setFieldValue(
                                      "availableBranches",
                                      branchListOptions
                                    )
                                    setIsAllSelected(true)
                                  } else {
                                    setFieldValue(
                                      "availableBranches",
                                      selectedValue
                                    )
                                    setIsAllSelected(
                                      selectedValue.length ===
                                        branchListOptions.length
                                    )
                                  }
                                }}
                                options={options}
                                placeholder={t("Select Branches")}
                                className={`select2-selection`}
                              />
                            </div>
                            <hr className="mt-3" />
                            <CardTitle>{t("Redemption")}</CardTitle>

                            <div className="col-lg-6">
                              <label htmlFor="amount">
                                {t("Max Usage Per Customer")}
                              </label>
                              <Switch
                                isChecked={
                                  values?.limits?.isMaxUsagePerCustomer
                                }
                                onClickHandler={() => {
                                  setFieldValue(
                                    "limits.isMaxUsagePerCustomer",
                                    !values?.limits?.isMaxUsagePerCustomer
                                  )
                                }}
                              />
                            </div>

                            <div className="col-lg-6">
                              <label htmlFor="amount">
                                {t("Max Usage Of Customers")}
                              </label>
                              <Switch
                                isChecked={
                                  values?.limits?.isMaxUsageOfCustomers
                                }
                                onClickHandler={() => {
                                  setFieldValue(
                                    "limits.isMaxUsageOfCustomers",
                                    !values?.limits?.isMaxUsageOfCustomers
                                  )
                                }}
                              />
                            </div>

                            {values?.limits?.isMaxUsagePerCustomer && (
                              <div className="col-lg-6">
                                <div className="form_field">
                                  <label htmlFor="maxUsagePerCustomer">
                                    <span className="text-danger">*</span>{" "}
                                    {t("Maximum redemptions per customer")}
                                  </label>
                                  <Field
                                    type="number"
                                    id="maxUsagePerCustomer"
                                    name="limits.maxUsagePerCustomer"
                                    placeholder={t(
                                      "Maximum redemptions per customer"
                                    )}
                                    className={`form-control ${
                                      touched?.limits?.maxUsagePerCustomer &&
                                      errors?.limits?.maxUsagePerCustomer
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    pattern="[0-9]*"
                                  />
                                  <TextError name="limits.maxUsagePerCustomer" />
                                </div>
                              </div>
                            )}

                            {values?.limits?.isMaxUsageOfCustomers && (
                              <div className="col-lg-6">
                                <div className="form_field">
                                  <label htmlFor="maxUsageOfCustomers">
                                    <span className="text-danger">*</span>{" "}
                                    {t(
                                      "Maximum redemptions across all customers"
                                    )}
                                  </label>
                                  <Field
                                    type="number"
                                    id="maxUsageOfCustomers"
                                    name="limits.maxUsageOfCustomers"
                                    placeholder={t(
                                      "Maximum redemptions across all customers"
                                    )}
                                    // className={`form-control`}
                                    className={`form-control ${
                                      touched?.limits?.maxUsageOfCustomers &&
                                      errors?.limits?.maxUsageOfCustomers
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    pattern="[0-9]*"
                                  />
                                  <TextError name="limits.maxUsageOfCustomers" />
                                </div>
                              </div>
                            )}
                          </>
                        )}

                        <div className="col-12 my-4">
                          <div className="d-flex align-items-center justify-content-end">
                            <Button
                              type="button"
                              color="secondary"
                              className=" mx-2"
                              onClick={() => window.history.back()}
                            >
                              {t("Cancel")}
                            </Button>
                            <Button
                              color="success"
                              type="submit"
                              style={{ width: "fit-content" }}
                              disabled={isLoading || isActionBusy}
                            >
                              {mode === "add" ? t("Add") : t("Save")}
                            </Button>
                          </div>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default AddPromotion
